import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import MobilitySolutionsHero from "./sections/MobilitySolutionsHero";
import EnterprisePartnershipHub from "./sections/EnterprisePartnershipHub";
import FeaturedFleetSelection from "./sections/FeaturedFleetSelection";
import MobilitySolutionMatrix from "./sections/MobilitySolutionMatrix";
import PrecisionCareTeaser from "./sections/PrecisionCareTeaser";
import ClientExperiences from "./sections/ClientExperiences";
import GoogleMapReviews from "./sections/GoogleMapReviews";
import GlobalFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <MobilitySolutionsHero />
      <EnterprisePartnershipHub />
      <FeaturedFleetSelection />
      <MobilitySolutionMatrix />
      <PrecisionCareTeaser />
      <ClientExperiences />
      <GoogleMapReviews />
      <GlobalFooter />
    </div>;
}